import React, { FC, memo } from "react";
import { useTranslation } from "react-i18next";

import { Header } from "@/components/Header";
import { Flex, Section } from "@/eworkitComponents";
import { IConsultantProfileSectionProps } from "@/views/components/ConsultantProfile/Sections/types";

interface Props extends IConsultantProfileSectionProps {}

export const ContactSection: FC<Props> = memo(props => {
  const { t } = useTranslation("session");

  const { children, record } = props;
  const contactPerson = record.contactPerson;

  return (
    <Section
      grow={1}
      direction="column"
      innerMargin="sm"
      testName={"contact-person" + contactPerson ? `[${contactPerson.id}]` : ""}>
      <Header size="sm" color="black" weight="bold">
        {t("CONSULTANT_PROFILES.DETAIL.CONTACT_PERSON.SECTION_HEADER")}
      </Header>
      <Flex grow={1} innerMargin="sm">
        {children}
      </Flex>
    </Section>
  );
});
